<template>
  <div>
    <a-modal
      :title="modalTitle"
      v-model="visible" 
      @cancel="handleCancel" 
      width="850px"
      v-bind:body-style="{ height: '400px' }"
    >
    <!-- 表单 -->
    <div >
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="searchList" :rules="rules" ref="ruleForm">
        <a-row>
          <a-col :span = "24">
            <a-form-model-item label="任务节点:" prop="taskNode">
              <a-input v-model="searchList.taskNode" :allowClear="true" placeholder="请输入任务节点"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "24">
            <a-form-model-item label="事件描述:" prop="taskInfo">
              <a-textarea :rows="4" v-model="searchList.taskInfo" :allowClear="true" placeholder="请输入事件描述"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "24">
            <a-form-model-item
              label="事件图片"
              :label-col="{ span: 4}"
              :wrapper-col="{ span: 18 }"
              required
            >
              <upload  :downid="progressId" uploadNum="3" :uploadAgain="uploadAgain" :fileNum="fileNum" @listen ="listen"></upload>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button class="cancel-color" ghost @click="handleCancel">取消</a-button>
      <a-button  class="btn-color" @click="handleOk" :loading="okLoad">确定</a-button>
    </template>
    </a-modal>
  </div>
</template>

<script>
import{ queryEmp,addProgress } from "@/api/api.js";
import upload from "@/components/upload/upload.vue";
export default {
  components: { upload },
  props: {
    modalTitle: {
      type: String,
      default: () => "",
    }, //标题
    progressId:{type:String},//服务进度主键
    data: {
      type: Object,
      default: () => [],
    },//返回信息
  },
  data() {
    return {
      imgUrl:"",
      visible: true,
      //固定宽度
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      okLoad: false,
      empList:[],//员工信息
      //绑定值
      searchList: {
        id: this.progressId,
        taskNode: "",
        taskInfo:"",
      },
      imgUrls:[],
      //校验规则
      rules: {
        taskNode: [
          {
            required: true,
            message: "任务节点不能为空！",
            trigger: "blur",
          },
          {
            max: 60,
            message: "不可超过60字",
            trigger: "blur",
          },
        ],
        taskInfo: [
          {
            required: true,
            message: "事件描述不能为空！",
            trigger: "blur",
          },
          {
            max: 400,
            message: "不可超过400字",
            trigger: "blur",
          },
        ],
      },
      uploadAgain:false,
      fileNum: 0,
      fileType:'01',//文件类型
    }
  },
  mounted() {
    this.searchList.id = this.progressId;
  },
  methods: {
    //取消
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
    },

    //监听附件组件
    listen(val) {
      this.uploadAgain = false;
      if(val.length == 0){
        this.imgUrl = false;
        this.imgUrls =[];
      }else if(val.length < 3){
        this.imgUrl = true;
        this.imgId = val[0].id;
        this.imgUrls.push(val[0].id);
        this.uploadAgain = false;//监听是否已上传要求数量以内的文件
      }else {
        this.imgUrl = true;
        this.imgId = val[0].id;
        this.imgUrls.push(val[0].id);
        this.uploadAgain = true;//监听是否已上传要求数量以内的文件
      }
      this.fileNum = val.length;
    },

    //添加事件
    handleOk() {
      //校验图片
      if (this.imgUrls == [] || this.imgUrls == null || this.imgUrls == undefined || this.imgUrls.length == 0) {
        return this.$message.warning("请上传配图！")
      }
      let paramObj={
        id:this.searchList.id,
        recNo:this.data.recNo,
        taskNode:this.searchList.taskNode,
        taskInfo:this.searchList.taskInfo
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.okLoad = true
          addProgress(paramObj).then(
              (res) => {
                if (res.code == '0000') {
                  this.okLoad = false;
                  this.$message.success('添加事件成功');
                  this.$emit('handleOk');
                }
              },
              (err) => {
                this.okLoad = false
              }
            )
        };
      })
    },
  },
}
</script>

<style scoped>
.btn-color {
    background: rgba(22, 130, 139, 1);
    border-color: rgba(22, 130, 139, 1);
    margin-right: 10px;
    color: white;
}
.cancel-color{
  border-color: rgba(22, 130, 139, 1);
  color: rgba(22, 130, 139, 1);
}
.button-save {
  border: none;
  background: #009de5;
  color: #fff;
  width: 90px;
  height: 30px;
}

.button-cancel {
  border: 1px #cccccc solid;
  background: #fff;
  color: #333;
  width: 90px;
  height: 30px;
}
</style>
